import { SliderBuffer } from "../../../../../../ui/slider/buffer.js";
import { SliderFill } from "../../../../../../ui/slider/fill.js";
import { SliderPreview } from "../../../../../../ui/slider/preview.js";
import { SliderThumb } from "../../../../../../ui/slider/thumb.js";
import { SliderTrack } from "../../../../../../ui/slider/track.js";
import { SliderValue } from "../../../../../../ui/slider/value.js";
import { TimeSliderRoot } from "../../../../../../ui/time-slider/root.js";
import { SliderBuffer as SliderBuffer$1, SliderFill as SliderFill$1, SliderThumb as SliderThumb$1, SliderTrack as SliderTrack$1 } from "../../../components/sliders/slider.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/shared/skins/shared/audio/time-slider.tsx
function AudioTimeSlider({ className, previewOverflow = "clamp", ...props } = {}) {
	return /* @__PURE__ */ jsxs(TimeSliderRoot, {
		className: (state) => cn("media-slider", "audio-time-slider", resolveClassName(className, state)),
		...props,
		children: [
			/* @__PURE__ */ jsxs(SliderTrack, {
				render: /* @__PURE__ */ jsx(SliderTrack$1, {}),
				children: [/* @__PURE__ */ jsx(SliderBuffer, { render: /* @__PURE__ */ jsx(SliderBuffer$1, {}) }), /* @__PURE__ */ jsx(SliderFill, { render: /* @__PURE__ */ jsx(SliderFill$1, {}) })]
			}),
			/* @__PURE__ */ jsx(SliderThumb, {
				render: /* @__PURE__ */ jsx(SliderThumb$1, {}),
				className: "audio-time-slider-thumb"
			}),
			/* @__PURE__ */ jsx(SliderPreview, {
				className: "media-slider-preview",
				overflow: previewOverflow,
				children: /* @__PURE__ */ jsx("div", {
					className: cn("media-slider-preview-content", "media-popup-surface", "media-tooltip", "audio-time-slider-preview-content"),
					children: /* @__PURE__ */ jsx(SliderValue, {
						className: "audio-time-slider-value",
						type: "pointer"
					})
				})
			})
		]
	});
}
//#endregion
export { AudioTimeSlider };

//# sourceMappingURL=time-slider.js.map